import React, { useEffect, useMemo, useState } from 'react';
import Button from '../../shared/components/ui/Button';
import { useForm } from 'react-hook-form';
import Table from '../../shared/components/layout/Table';
import EditTable from '../../shared/components/layout/EditTable';
import { transformData } from '../../super-admin/utils/transformData';
import Modal from '../../shared/components/ui/Modal';
import { ImportBlock } from '../components/forms/ImportBlock';
import AddNewBlock from '../components/forms/AddNewBlock';
import EditBlock from '../components/forms/EditBlock';
import EditProject from '../components/forms/EditProject';
import { EditBasement } from '../components/forms/EditBasement';
import { EditUnit } from '../components/forms/EditUnit';
import { EditGround } from '../components/forms/EditGround';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import UpdateLevel from '../components/forms/UpdateLevel';
import {
  createBLock,
  createLevel,
  cretaeUnit,
  deleteAccomodation,
  editBlock,
  editLevel,
  editUnits,
  getAllAccommodationsByProject,
  getAllBlocks,
  getBlockByID,
  getLevelById,
  deleteBlock,
  handleCheckBlockDelete,
  handleCheckLevelDelete,
  deleteLevel,
  handleCheckUnitDelete,
  deleteUnit,
  editProject,
  getProjectByID,
  getBuildingsByProjectId,
  getSalesManagerUsers,
  bulkBookUnits
} from '../services/api/implementation/impl';
import toast from 'react-hot-toast';
import { EditFloor } from '../components/forms/EditFloor';
import { useParams } from 'react-router-dom';
import { EditLevel } from '../components/forms/EditLevel';
import UpdateUnit from '../components/forms/UpdateUnit';
import leftarrow from '../../shared/assets/svg/left_arrow.svg';

import BlocksStatic from '../../builder/static/data/BlockStatic.json';
import generateLevelPayload from '../utils/generateLevelPayload';
import backbtnIcon from '../../shared/assets/svg/backbtn.svg';

import { getAllAccommodations } from '../services/api/implementation/impl';
import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import {
  List,
  Plus,
  LayoutGrid,
  Building2,
  Ruler,
  User,
  Search,
  CheckCircle2,
  CircleDot,
  Pencil,
  Trash2
} from 'lucide-react';
import BlockHierarchy from '../components/layout/BlockHierarchy';
import BulkAssignSalesManagerModal from '../components/BulkAssignSalesManagerModal';
import MetricCard from '../components/ui/MetricCard';
import Loader from '../../shared/components/ui/Loader';
import { PROJECT_SETUP_TYPES } from '../utils/projectStructurePriorities';
import { triggerProjectStructureReview } from '../utils/triggerProjectStructureReview';

export const BlockDetails = () => {
  const queryClient = useQueryClient();
  const userId = Cookies.get('userId');
  const userVertical = Cookies.get('userVertical');
  const userLevel = Cookies.get('userDesignationLevel');
  const canAssignSalesManager =
    userVertical === 'Management' ||
    (userVertical === 'Sales' && (userLevel === 'High' || userLevel === 'Medium'));

  const style = { width: `20%` };

  /* 
    Hooks
  */
  const { id: projectId } = useParams();

  // Track page view
  useEffect(() => {
    mixpanel.track('Block Details Viewed', {
      user_id: userId,
      project_id: projectId,
      timestamp: new Date().toISOString()
    });
  }, [userId, projectId]);

  /* 
    Hooks
  */
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors }
  } = useForm();

  /* 
    Local state
  */
  const [isOpenAddNewBlock, setIsOpenAddNewBlock] = useState(false);
  const [newBlockId, setNewBlockId] = useState(null);
  const [blockLevelStaticArray, setBlockLevelStaticArray] = useState(BlocksStatic);
  const [blocksArray, setBlocksArray] = useState([]);
  const [isEditBlockLevel, setIsEditBlockLevel] = useState(false);

  // Edit Project Modal states
  const [isOpenEditProject, setIsOpenEditProject] = useState(false);
  const [upShift, setUpShift] = useState(6);

  // For Level Unit Edit Modal
  const [levelsDyna, setLevelsDyna] = useState([]);
  const [currentLevelIndex, setCurrentLevelIndex] = useState(0);
  const [isOpenEditLevelUnitModal, setisOpenEditLevelModal] = useState(false);

  //For Unit view
  const [activeBlock, setActiveBlock] = useState([]);
  const [viewUnits, setViewUnits] = useState(false);
  const [blocksDynaWithLevels, setBlocksDynaWithLevels] = useState([]);
  const [activeLevelType, setActiveLevelType] = useState('');
  const [HeaderByLevelName, setHeaderByLevelName] = useState('');
  const [isAllUnitDataSubmitted, setisAllUnitDataSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [blockType, setBlockType] = useState('');
  const [type, setType] = useState();

  const [currentBlockName, setCurrentBlockName] = useState('');
  const [blockLevelNumber, setBlockLevelNumber] = useState(0);
  const [isSaved, setIsSaved] = useState(false);

  const [prevLevelData, setPrevLevelData] = useState([]);
  const { collapsed } = useSidebar();
  const [resData, setResData] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [showBulkAssignModal, setShowBulkAssignModal] = useState(false);
  const [isBulkAssignSubmitting, setIsBulkAssignSubmitting] = useState(false);
  const [canDelete, setCanDelete] = useState(null);
  const [deleteType, setDeleteType] = useState('');
  const [viewMode, setViewMode] = useState('card');
  const [searchQuery, setSearchQuery] = useState('');
  const [blockTypeFilter, setBlockTypeFilter] = useState('all');

  /*
    Data fetching
  */
  const {
    data: blocksDyna,
    refetch: refetchBlocks,
    isLoading: isBlocksLoading,
    isFetching: isBlocksFetching
  } = useQuery({
    queryKey: ['blocks', projectId],
    queryFn: () => getAllBlocks(projectId),
    enabled: !!projectId
  });

  useEffect(() => {
    if (projectId) {
      refetchBlocks();
    }
  }, [projectId]);

  const {
    data: blockDyna,
    refetch: refetchBlock,
    isLoading: isBlockLoading,
    isFetching: isBlockFetching
  } = useQuery({
    queryKey: ['block', newBlockId],
    queryFn: () => getBlockByID(newBlockId),
    enabled: !!newBlockId
  });

  // Queries for EditProject functionality
  const { data: buildingByProjectId, refetch: refetchBuildingByProjectId } = useQuery({
    queryKey: ['buildingByProjectId', projectId],
    queryFn: () => getBuildingsByProjectId(projectId),
    enabled: !!projectId
  });

  const { data: accommodations, refetch: refetchAccommodations } = useQuery({
    queryKey: ['accommodations', projectId],
    queryFn: () => getAllAccommodationsByProject(projectId)
  });

  const { data: projectData, refetch: refetchProjectData } = useQuery({
    queryKey: ['projectData', projectId],
    queryFn: () => getProjectByID(projectId),
    enabled: !!projectId
  });

  const { data: salesManagersData } = useQuery({
    queryKey: ['salesManagerUsers'],
    queryFn: () => getSalesManagerUsers(1, 5000)
  });

  const salesManagerNameById = useMemo(() => {
    const map = {};
    (salesManagersData?.data ?? []).forEach((user) => {
      map[String(user.id)] = user.name || user.email || `User ${user.id}`;
    });
    return map;
  }, [salesManagersData?.data]);

  const salesManagerOptions = useMemo(() => {
    const all = salesManagersData?.data ?? [];
    if (userVertical === 'Management' || (userVertical === 'Sales' && userLevel === 'High')) {
      return all;
    }
    if (userVertical === 'Sales' && userLevel === 'Medium') {
      return all.filter((u) => String(u.id) === String(userId));
    }
    return [];
  }, [salesManagersData?.data, userVertical, userLevel, userId]);

  console.log('blockDyna', blockDyna);

  // const blocksDynaWithLevels = blocksDyna?.blocks?.filter((block) => block?.levels?.length > 0);
  /* 
    Effects
  */
  useEffect(() => {
    if (newBlockId) {
      refetchBlock(newBlockId);
      setCurrentBlockName(blockDyna?.name);
    }
  }, [newBlockId, refetchBlock, currentLevelIndex, currentBlockName]);

  //setting block type

  useEffect(() => {
    if (!blockType && blockDyna?.type) {
      setBlockType(blockDyna.type);
      setBlockLevelNumber(blockDyna?.numberOfLevels);
      setCurrentBlockName(blockDyna?.name);
    }
  }, [blockDyna, blockType, blockLevelNumber, setCurrentBlockName]);

  useEffect(() => {
    setType(blockDyna?.type);
  }, [blockDyna]);

  // This useEffect runs only after blockType is set
  useEffect(() => {
    if (blockLevelNumber && blockType && blockDyna) {
      const newBlocksArray = Array.from({ length: blockLevelNumber }, (_, index) => {
        const hasAccommodationUnitTypeResdential = accommodations?.some(
          (acc) => acc.unitType.toLowerCase() === 'residential'
        );
        console.log('hasAccommodationUnitTypeResdential', hasAccommodationUnitTypeResdential);

        const hasAccommodationUnitTypeCommercial = accommodations?.some(
          (acc) => acc.unitType.toLowerCase() === 'commercial'
        );
        console.log('hasAccommodationUnitTypeCommercial', hasAccommodationUnitTypeCommercial);
        console.log('accommodations', { accommodations });

        const accommodationStr = blockLevelStaticArray.accommodation_type;
        const dropdownPattern = /dropdown-(.*)/;
        const matches = accommodationStr.match(dropdownPattern);
        let dropdownArrayStr = matches && matches[1] ? matches[1] : '[]';

        // Convert the extracted string into a JS array
        let accommodationOptions;
        try {
          accommodationOptions = JSON.parse(dropdownArrayStr);
        } catch (error) {
          // If there's a parse error, fallback to a default array
          accommodationOptions = [
            { value: 'RESIDENTIAL', label: 'RESIDENTIAL' },
            { value: 'COMMERCIAL', label: 'COMMERCIAL' },
            { value: 'PARKING', label: 'PARKING' },
            { value: 'SERVICES', label: 'SERVICES' }
          ];
        }

        // Conditionally remove RESIDENTIAL if not present in accommodations
        if (!hasAccommodationUnitTypeResdential) {
          accommodationOptions = accommodationOptions.filter((opt) => opt.value !== 'RESIDENTIAL');
        }

        // Conditionally remove COMMERCIAL if not present in accommodations
        if (!hasAccommodationUnitTypeCommercial) {
          accommodationOptions = accommodationOptions.filter((opt) => opt.value !== 'COMMERCIAL');
        }

        // Recreate the accommodation_type string
        const newAccommodationType = `dropdown-${JSON.stringify(accommodationOptions)}`;

        const newBlock = {
          ...blockLevelStaticArray,
          level_name: blockType === 'Independent' ? `Row` : `Level ${index}`,
          accommodation_type: newAccommodationType,
          num_units: ''
        };

        setValue(`Level Name-${index}`, newBlock.level_name);
        return newBlock;
      });

      setBlocksArray(newBlocksArray);
    }
  }, [blockLevelNumber, blockType, blockDyna, blockLevelStaticArray, setValue]);
  console.log(blocksArray, 'blocksArray');

  useEffect(() => {
    if (blocksDyna) {
      if (blocksDyna) {
        const sorted =
          blocksDyna && blocksDyna.length > 0
            ? [...blocksDyna].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            : [];

        if (sorted.length > 0) {
          setBlocksDynaWithLevels(sorted);
          // Do not auto-select a block; show blocks table first
        }
      }
    }
  }, [blocksDyna]);

  /*
    Data mutation
  */
  const { mutate: handleAddBlock } = useMutation({
    mutationFn: (payload) => createBLock(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (data) => {
      setIsSubmitting(false);
      type;
      setNewBlockId(data?.id);
      setBlockType(data?.type);
      setBlockLevelNumber(data?.numberOfLevels);
      setIsEditBlockLevel(true);
      setIsOpenAddNewBlock(false);
      await triggerProjectStructureReview(projectId, PROJECT_SETUP_TYPES.BLOCK);
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error creating new block', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error creating new block');
    }
  });
  const handlePreviewCreatedBlock = async (data) => {
    // Filter the data to include only the relevant levels
    const filteredData = {};
    for (let i = 0; i < blockLevelNumber; i++) {
      filteredData[`Level Name-${i}`] = data[`Level Name-${i}`];
      filteredData[`No of Units-${i}`] = data[`No of Units-${i}`];
      filteredData[`Floor Type-${i}`] = data[`Floor Type-${i}`];
    }

    const payload = generateLevelPayload({
      ...filteredData,
      block_id: blockDyna?.id,
      project_id: projectId
    });

    try {
      const res = await createLevel(payload);
      setisOpenEditLevelModal(true);
      setLevelsDyna(res);
    } catch (error) {
      console.error('Error creating level:', error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Failed to create level. Please try again.'
      );
    }
  };

  const handleEditLevel = async (data) => {
    console.warn('Data: testing', data);
    setPrevLevelData((prev) => [...prev, data]);
    // Extracting unit names and accommodation names
    let units = Object.keys(data)
      .filter((key) => key.startsWith('Unit Name-'))
      ?.map((key, index) => {
        const unitName = data[key];
        const accommodationKey = `Accommodation Name-${index}`;
        const accommodationName = data[accommodationKey] || '';

        console.warn(accommodationName, 'accommodationName');

        return {
          unit_name: unitName,
          accomodation_id: parseInt(accommodationName)
        };
      });

    // Validate units
    const allFieldsFilled = units.every((unit) => unit.unit_name && unit.accomodation_id);
    if (!allFieldsFilled) {
      toast.error('Please fill n all the fields');
      return;
    }

    let payload = {
      project_id: projectId,
      block_id: blockDyna?.id,
      level_id: levelsDyna[currentLevelIndex].id, // Use the current level's ID
      units
    };

    try {
      const response = await cretaeUnit(payload);
      if (currentLevelIndex < blockLevelNumber - 1) {
        setCurrentLevelIndex(currentLevelIndex + 1);
        setisOpenEditLevelModal(true); // Reopen the modal with the next level
      } else {
        setisOpenEditLevelModal(false); // Close the modal if it's the last level
        setisAllUnitDataSubmitted(true);
        setIsEditBlockLevel(false);
        await triggerProjectStructureReview(projectId, PROJECT_SETUP_TYPES.UNIT);
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || err?.message || 'Failed to create units. Please try again.'
      );
      console.error('Unit creation error:', err);
    }
  };

  const handleSaveAddBlock = async () => {
    setIsSaved(true);
    await refetchBlocks(projectId); // Refresh the block data from API
    await refetchBlock(newBlockId); // Refresh the specific block data

    // Resetting state variables
    setIsEditBlockLevel(false);
    setisAllUnitDataSubmitted(false);
    setLevelsDyna([]); // Reset levels data
    setBlocksArray([]); // Reset blocks data
    setBlockLevelNumber(0); // Reset 0the level number
    setBlockType(''); // Reset block type
    setCurrentBlockName(''); // Reset block name
    setNewBlockId(null); // Clear new block ID
    setIsSaved(false);
    setCurrentLevelIndex(0); // Reset the current level index

    // If you want to reset form fields as well
    reset(); // useForm's reset to clear all fields

    toast.success('Block saved successfully');
    window.location.reload();
    await refetchBlocks(projectId);
  };
  blockType;

  const blockDataByIdFormat = ['id', 'name', 'floorType', 'noOfUnits', 'actions'];

  const BlockDataId =
    blockDyna?.levels?.map((item) =>
      transformData(
        {
          ...item,
          name: <span className="text-[#0F172A] font-medium">{item?.name || '---'}</span>
        },
        blockDataByIdFormat
      )
    ) || [];

  useEffect(() => {
    if (viewUnits && blockDyna?.levels && activeBlock?.[0]?.id) {
      // Use the ID of the currently active level to update the active block state
      const updatedActiveBlock = blockDyna?.levels?.filter(
        (item) => parseInt(item.id) === parseInt(activeBlock?.[0]?.id)
      );
      setActiveBlock(updatedActiveBlock);
    }
  }, [blockDyna]);

  const handleViewForType = (id) => {
    const filterType = blockDyna?.levels?.filter((item) => parseInt(item.id) === parseInt(id));
    setActiveBlock(filterType);
    setActiveLevelType(filterType[0]?.floorType);
    setHeaderByLevelName(filterType[0]?.name);
    setViewUnits(true);
  };

  const handleSelectBlockChange = (event) => {
    setNewBlockId(event.target.value);
  };

  const goBackToBlocks = () => {
    setViewUnits(false);
    setActiveBlock([]);
    setActiveLevelType('');
    setHeaderByLevelName('');
    setNewBlockId(null);
  };

  const backToLevels = () => {
    setViewUnits(false);
  };

  // Unit heders

  const showBulkSalesManagerAssign =
    viewUnits && canAssignSalesManager && activeLevelType !== 'PARKING';

  const commercialHeader = [
    'Unit Name',
    'Acc. Type',
    'Build Up Area',
    'Carpet Area',
    'Loading Factor',
    'Super Build Up',
    'Sales Manager',
    'Status',
    'Actions'
  ];

  const residentialHeader = [
    'Unit Name',
    'Acc. Type',
    'Acc. Name',
    ...(type === 'Independent' ? ['Plot Area'] : []),
    'Build Up Area',
    'Carpet Area',
    'Sales Manager',
    'Status',
    'Actions'
  ];

  const parkingHeader = [
    'Unit Name',
    'Acc. Type',
    'Acc. Name',
    'Area',
    'Electrified',
    'Status',
    'Actions'
  ];

  const commercialDataFields = [
    'unitName',
    'accommodationType',
    'buildUpArea',
    'carpetArea',
    'loadingFactor',
    'superBuiltUpArea',
    'salesManagerName',
    'status',
    'actions',
    'id'
  ];
  const residentialDataFields = [
    'unitName',
    'accommodationType',
    'accommodationName',
    ...(type === 'Independent' ? ['plotArea'] : []),
    'buildUpArea',
    'carpetArea',
    'salesManagerName',
    'status',
    'actions',
    'id'
  ];

  const parkingDataFields = [
    'unitName',
    'accommodationType',
    'accommodationName',
    'buildUpArea',
    'electrified',
    'status',
    'actions',
    'id'
  ];

  const headers =
    activeLevelType === 'PARKING'
      ? parkingHeader
      : activeLevelType === 'COMMERCIAL'
        ? commercialHeader
        : residentialHeader;
  const dataFields =
    activeLevelType === 'PARKING'
      ? parkingDataFields
      : activeLevelType === 'COMMERCIAL'
        ? commercialDataFields
        : residentialDataFields;

  const getUnitSalesManagerName = (unit) => {
    const managerId =
      unit?.sales_manager_id ?? unit?.salesManager?.id ?? unit?.sales_manager?.id ?? null;
    return (
      unit?.salesManager?.name ||
      unit?.sales_manager?.name ||
      unit?.salesManager?.user?.name ||
      (managerId != null ? salesManagerNameById[String(managerId)] : null) ||
      '—'
    );
  };

  const dataFieldUnits = activeBlock?.[0]?.units?.map((item) =>
    transformData(
      {
        ...item,
        unitName: <span className="text-[#0F172A] font-medium">{item?.unitName || '---'}</span>,
        accommodationName: item?.accommodation?.name,
        accommodationType: item?.accommodation?.accomodationType,
        carpetArea: item?.accommodation?.carpetArea,
        plotArea: item?.accommodation?.plotArea,
        buildUpArea: item?.accommodation?.buildUpArea,
        superBuiltUpArea: item?.accommodation?.superBuiltUpArea,
        loadingFactor: item?.accommodation?.loadingFactor,
        electrified: item?.accommodation?.electrified,
        salesManagerName: getUnitSalesManagerName(item)
      },
      dataFields
    )
  );

  const unitDetailsForEdit = activeBlock?.[0]?.units;
  // const dataFieldUnits = activeBlock?.[0]?.units;

  // Edit Codes
  const [isEditingBlock, setIsEditingBlock] = useState(false);
  const [isEditUnit, setIsEditUnit] = useState(false);
  const [UnitId, setUnitId] = useState(null);

  const { mutate: handleEditBlock } = useMutation({
    mutationFn: (payload) => {
      editBlock(newBlockId, payload);
    },
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (data) => {
      setIsSubmitting(false);
      toast.success('Block Updated successfully');
      setIsEditingBlock(false);
      setNewBlockId(null);
      await refetchBlocks(projectId);
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error  updating block', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error Updating new block');
    }
  });

  const { mutate: handleBulkAssignSalesManager } = useMutation({
    mutationFn: (payload) => bulkBookUnits(payload),
    onMutate: () => {
      setIsBulkAssignSubmitting(true);
    },
    onSuccess: async () => {
      setIsBulkAssignSubmitting(false);
      toast.success('Sales manager assigned successfully');
      setShowBulkAssignModal(false);
      queryClient.invalidateQueries(['block', newBlockId]);
      await refetchBlock(newBlockId);
    },
    onError: (err) => {
      setIsBulkAssignSubmitting(false);
      console.error('Error bulk assigning sales manager', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error assigning sales manager');
    }
  });

  const { mutate: handleEditUnits } = useMutation({
    mutationFn: (payload) => editUnits(UnitId, payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (data) => {
      setIsSubmitting(false);
      toast.success('Unit updated successfully');
      setIsEditUnit(false);
      queryClient.invalidateQueries(['block', newBlockId]);
      await refetchBlock(newBlockId);
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error updating unit', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error updating unit');
    }
  });

  // EditProject mutation
  const { mutate: handleEditProject, isLoading: isEditingProject } = useMutation({
    mutationFn: (updatedProject) => {
      if (!updatedProject) {
        throw new Error('updatedProject is null or undefined');
      }

      if (projectId == null) {
        throw new Error('projectId is null or undefined');
      }

      let parsedLandId;
      try {
        parsedLandId = updatedProject.land_id != null ? parseInt(updatedProject.land_id, 10) : null;
        console.log('Parsed land_id:', parsedLandId);
      } catch (error) {
        console.error('Error parsing land_id:', error);
        throw new Error(`Failed to parse land_id: ${error.message}`);
      }

      const projectToEdit = {
        ...updatedProject,
        land_id: parsedLandId
      };

      console.log('Project to edit:', JSON.stringify(projectToEdit, null, 2));

      return editProject(projectId, projectToEdit);
    },
    onMutate: (variables) => {
      setIsSubmitting(true); // Disable the button when mutation starts
      mixpanel.track('Edit Project Started', {
        user_id: userId,
        project_id: projectId,
        project_name: variables?.name,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async (result, variables) => {
      setIsSubmitting(false);

      // Check if result is an error object (API now returns errors instead of throwing)
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        // Handle as error
        console.error('Error editing project:', result);
        toast.error(result?.response?.data?.message || result?.message || 'Error editing project');

        mixpanel.track('Edit Project Failed', {
          user_id: userId,
          project_id: projectId,
          project_name: variables?.name,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        return;
      }

      // Handle success
      console.log('Edit project succeeded');
      toast.success('Project edited successfully');
      setIsOpenEditProject(false);
      await refetchProjectData(projectId);
      await refetchBuildingByProjectId();

      mixpanel.track('Edit Project Success', {
        user_id: userId,
        project_id: projectId,
        project_name: variables?.name || result?.name,
        timestamp: new Date().toISOString()
      });
    },
    onError: (err, variables) => {
      setIsSubmitting(false);
      console.error('Error editing project:', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error editing project');

      mixpanel.track('Edit Project Failed', {
        user_id: userId,
        project_id: projectId,
        project_name: variables?.name,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  const handleEditUnitById = (id) => {
    setUnitId(id);
    setIsEditUnit(!isEditUnit);
  };
  const handleCloseEditUnitModal = async () => {
    setIsEditUnit(false);
    await refetchBlock();
  };
  const isTypingNow = (value, index) => {
    const updatedBlocksArray = [...blocksArray];

    if (index === 0 && value.startsWith('Level ')) {
      // Extract the number from the first level name
      const levelNumber = parseInt(value.replace('Level ', ''), 10);

      if (!isNaN(levelNumber)) {
        // Update the first row
        updatedBlocksArray[0].level_name = value;

        // Propagate the change to subsequent rows
        for (let i = 1; i < updatedBlocksArray.length; i++) {
          updatedBlocksArray[i].level_name = `Level ${levelNumber + i}`;
        }

        // Update the form values dynamically using setValue for each field
        updatedBlocksArray.forEach((block, idx) => {
          setValue(`Level Name-${idx}`, block.level_name); // Update form state for each level name
        });

        // Update the state with the new array
        setBlocksArray(updatedBlocksArray);
      } else {
        toast.error('Please enter a valid number after "Level"');
      }
    } else if (value.startsWith('Level ')) {
      // Handle updates to other rows that start with "Level"
      const levelNumber = parseInt(value.replace('Level ', ''), 10);

      if (!isNaN(levelNumber)) {
        // Update the specific row
        updatedBlocksArray[index].level_name = value;
        setBlocksArray(updatedBlocksArray);
        setValue(`Level Name-${index}`, value); // Update form state for the specific level name
      } else {
        toast.error('Please enter a valid number after "Level"');
      }
    } else if (!value.startsWith('Level')) {
      // Handle updates to No of Units, Floor Type, or other fields
      updatedBlocksArray[index].num_units = value;
      setBlocksArray(updatedBlocksArray);
      setValue(`No of Units-${index}`, value);
    } else {
      // If none of the conditions match, show an error to prevent incorrect input
      toast.error('You can only edit the number after "Level"');
    }
  };

  // console.log("isTypingNow", isTypingNow);
  const [isUpdateUnitModalOpen, setIsUpdateUnitModalOpen] = useState(false);
  const [isUpdateLevelModalOpen, setIsUpdateLevelModalOpen] = useState(false);

  const addUnitHandler = () => {
    console.log('addUnitHandler');
    setIsUpdateUnitModalOpen(true);
  };
  const addLevelHandler = () => {
    console.log('addLevelHandler');
    setIsUpdateLevelModalOpen(true);
  };

  const handleAddFloatingLevel = () => {
    const nextIndex = blocksArray.length;
    const baseRow = blocksArray[0] || blockLevelStaticArray;
    const nextLevelName = blockType === 'Independent' ? 'Row' : `Level ${nextIndex}`;

    const newLevelRow = {
      ...baseRow,
      level_name: nextLevelName,
      num_units: ''
    };

    setBlocksArray((prev) => [...prev, newLevelRow]);
    setBlockLevelNumber((prev) => prev + 1);
    setValue(`Level Name-${nextIndex}`, nextLevelName);
    setValue(`No of Units-${nextIndex}`, '');
  };

  const handleUpdateUnit = async (payload) => {
    console.log('handleUpdateUnit', payload);
    await cretaeUnit(payload);
    await refetchBlock(newBlockId);
    // queryClient.invalidateQueries(['block', newBlockId]);
    setIsUpdateUnitModalOpen(false);
    queryClient.invalidateQueries(['block', newBlockId]);
  };

  const handleUpdateLevel = async (payload) => {
    console.log('handleUpdateLevel', payload);
    await createLevel(payload);
    await refetchBlock(newBlockId);
    setIsUpdateLevelModalOpen(false);
    queryClient.invalidateQueries(['block', newBlockId]);
  };

  console.log(blocksArray, 'setBlocksArray[0]?.floorType');

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => handleCheckBlockDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const BlockName = blockDyna?.name || 'block';
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: BlockName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...res, name: BlockName });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');
    }
  });

  const { mutate: handleDeleteLevel } = useMutation({
    mutationFn: (id) => handleCheckLevelDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const level = blockDyna?.levels?.find((item) => parseInt(item.id) === parseInt(id));
      const LevelName = level?.name || 'level';
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: LevelName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...res, name: LevelName });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');
    }
  });

  const { mutate: handleDeleteUnit } = useMutation({
    mutationFn: (id) => handleCheckUnitDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const unit = activeBlock?.[0]?.units?.find((item) => parseInt(item.id) === parseInt(id));
      const UnitName = unit?.unitName || 'unit';
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: UnitName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...res, name: UnitName });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteBlock(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('Block Deleted Successfully');
      refetchBlocks();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting block', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting block');
    }
  });

  const { mutate: handleDeleteLevelFn } = useMutation({
    mutationFn: (payload) => deleteLevel(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Level Deleted Successfully');
      await refetchBlock();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting Level', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting Level');
    }
  });

  const { mutate: handleDeleteUnitFn } = useMutation({
    mutationFn: (payload) => deleteUnit(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('Unit Deleted Successfully');
      refetchBlock();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting Unit', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting Unit');
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };
    if (deleteType === 'Block') {
      handleDeleteFn(payload);
    }

    if (deleteType === 'Level') {
      handleDeleteLevelFn(payload);
    }

    if (deleteType === 'Unit') {
      handleDeleteUnitFn(payload);
    }
  };

  // Add this function to ensure latest data is used when clicking a level
  const handleLevelClick = async (id) => {
    await refetchBlock();
    handleViewForType(id);
  };

  // New: build blocks table rows and table handlers
  const blockTableFormat = [
    'id',
    'name',
    'type',
    'numberOfLevels',
    'accommodationTypeCount',
    'operationsManagerName',
    'actions'
  ];
  const blockTypeOptions = [
    'all',
    ...new Set(blocksDynaWithLevels?.map((block) => block?.type).filter(Boolean))
  ];
  const filteredBlocks = (blocksDynaWithLevels || []).filter((block) => {
    const matchesSearch = (block?.name || '')
      .toLowerCase()
      .includes(searchQuery.toLowerCase().trim());
    const matchesType = blockTypeFilter === 'all' || block?.type === blockTypeFilter;
    return matchesSearch && matchesType;
  });
  const blocksTableRows =
    filteredBlocks?.map((item) => {
      const allUnitsForBlock = item?.levels?.flatMap((level) => level?.units || []) || [];
      const accommodationTypeCount = new Set(
        allUnitsForBlock.map((unit) => unit?.accommodation?.name).filter(Boolean)
      ).size;
      return transformData(
        {
          ...item,
          accommodationTypeCount,
          operationsManagerName: item?.operationsManager?.name || '--',
          name: <span className="text-[#0F172A] font-medium">{item?.name || '---'}</span>
        },
        blockTableFormat
      );
    }) || [];

  const handleBlockRowClick = (id) => {
    setViewUnits(false);
    setActiveBlock([]);
    setNewBlockId(id);
  };

  const handleEditBlockRow = (id) => {
    setNewBlockId(id);
    setIsEditingBlock(true);
  };

  const handleDeleteBlockRow = (id) => {
    setDeleteType('Block');
    handleCheckDelete(id);
  };

  const blockTypeTagClassName = (type) => {
    const key = String(type || '')
      .trim()
      .toLowerCase();
    const base =
      'inline-flex items-center shrink-0 rounded-full border px-3 py-1 text-[10px] font-bold uppercase tracking-wide';
    if (key === 'independent') {
      return `${base} bg-[#E8F6F4] text-[#0F766E] border-[#A7D7CF]`;
    }
    if (key === 'group') {
      return `${base} bg-[#EEF2FF] text-[#4338CA] border-[#C7D2FE]`;
    }
    if (key === 'parking') {
      return `${base} bg-[#FFF7ED] text-[#C2410C] border-[#FDBA74]`;
    }
    return `${base} bg-[#F1F5F9] text-[#475569] border-[#E2E8F0]`;
  };

  const showBlockCards = !isEditBlockLevel && viewMode === 'card' && !newBlockId && !viewUnits;
  const showOverviewStatsAndFilters =
    !isEditBlockLevel && !isAllUnitDataSubmitted && !newBlockId && !viewUnits;
  const showRowLevelStats =
    !isEditBlockLevel && !isAllUnitDataSubmitted && !!newBlockId && !viewUnits;
  const selectedBlockLevels = blockDyna?.levels || [];
  const totalRowsOrLevels = selectedBlockLevels.length;
  const totalUnitsInSelectedBlock =
    selectedBlockLevels.reduce((total, level) => total + (level?.units?.length || 0), 0) || 0;
  /** Count of distinct accommodation names linked to units (e.g. 2bhk, 1bhk), not accommodationType. */
  const totalDistinctAccommodationNames =
    new Set(
      selectedBlockLevels
        .flatMap((level) => level?.units || [])
        .map((unit) => unit?.accommodation?.name)
        .filter(Boolean)
    ).size || 0;
  const totalBlocks = blocksDynaWithLevels?.length || 0;
  const totalLevelsOrRows =
    blocksDynaWithLevels?.reduce((total, block) => total + (block?.levels?.length || 0), 0) || 0;
  const totalUnits =
    blocksDynaWithLevels?.reduce(
      (total, block) =>
        total +
        (block?.levels?.reduce(
          (levelTotal, level) => levelTotal + (level?.units?.length || 0),
          0
        ) || 0),
      0
    ) || 0;

  const showUnitLevelStats =
    !isEditBlockLevel && !isAllUnitDataSubmitted && !!newBlockId && viewUnits;

  const activeLevelUnitsList = activeBlock?.[0]?.units || [];

  const bulkAssignUnitsList = useMemo(
    () =>
      activeLevelUnitsList.map((unit) => ({
        id: unit.id,
        unitName: unit.unitName,
        salesManagerName: getUnitSalesManagerName(unit)
      })),
    [activeLevelUnitsList, salesManagerNameById]
  );

  const handleBulkAssignSubmit = (salesManagerId, unitIds) => {
    if (!salesManagerId) {
      toast.error('Please select a sales manager');
      return;
    }
    if (!unitIds?.length) {
      toast.error('Select at least one unit');
      return;
    }

    handleBulkAssignSalesManager({
      ids: unitIds,
      sales_manager_id: parseInt(salesManagerId, 10)
    });
  };

  /** Matches API payloads where each unit has `status`: "Vacant" | "Booked" (see getBlockByID). */
  const normalizeUnitInventoryStatus = (unit) =>
    String(unit?.status ?? unit?.unitStatus ?? unit?.unit_status ?? unit?.bookingStatus ?? '')
      .trim()
      .toUpperCase();

  const unitsTotalInLevelView = activeLevelUnitsList.length;
  const unitsVacantInLevelView = activeLevelUnitsList.filter((unit) => {
    const s = normalizeUnitInventoryStatus(unit);
    return s === 'VACANT';
  }).length;
  const unitsBookedInLevelView = activeLevelUnitsList.filter((unit) => {
    if (unit?.is_booked === true || unit?.isBooked === true) return true;
    if (unit?.lead_id != null || unit?.leadId != null) return true;
    const s = normalizeUnitInventoryStatus(unit);
    if (s === 'BOOKED') return true;
    if (s === 'VACANT' || !s) return false;
    return /BOOK|SOLD|CLOSED|UNDER|BLOCK/.test(s);
  }).length;

  const isOverviewLoading =
    !!projectId &&
    !isEditBlockLevel &&
    !isAllUnitDataSubmitted &&
    !newBlockId &&
    (isBlocksLoading || isBlocksFetching);

  const isBlockDetailLoading =
    !!projectId &&
    !isEditBlockLevel &&
    !isAllUnitDataSubmitted &&
    !!newBlockId &&
    (isBlockLoading || isBlockFetching);

  const isPageLoading = isOverviewLoading || isBlockDetailLoading;

  return (
    <>
      <Loader isVisible={isPageLoading} />
      {isUpdateLevelModalOpen && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name={'Update Levels'}
          width={55}
          onClose={() => setIsUpdateLevelModalOpen(false)}>
          <UpdateLevel
            blockId={newBlockId}
            levelId={activeBlock[0]?.id}
            floorTypeOptions={blocksArray[0]?.accommodation_type}
            onClose={() => setIsUpdateLevelModalOpen(false)}
            handleUpdateLevel={handleUpdateLevel}
          />
        </Modal>
      )}
      {isUpdateUnitModalOpen && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name={'Update Units'}
          width={55}
          onClose={() => setIsUpdateUnitModalOpen(false)}>
          <UpdateUnit
            blockId={newBlockId}
            levelId={activeBlock[0]?.id}
            activeLevelType={activeLevelType}
            onClose={() => setIsUpdateUnitModalOpen(false)}
            handleUpdateUnit={handleUpdateUnit}
          />
        </Modal>
      )}
      {/* EDITING CODES  */}
      {isEditingBlock && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={68}
          name={'Edit block'}
          onClose={() => {
            setIsEditingBlock(false);
            setNewBlockId(null);
          }}>
          <EditBlock
            data={blockDyna}
            blockId={newBlockId}
            isSubmitting={isSubmitting}
            setIsEditingBlock={setIsEditingBlock}
            onProceed={handleEditBlock}
            onClose={() => {
              setIsEditingBlock(false);
              setNewBlockId(null);
            }}
            buildingByProjectId={buildingByProjectId}
            setIsOpenEditProject={setIsOpenEditProject}
          />
        </Modal>
      )}

      {isEditUnit && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name={'Edit Unit'}
          width={60}
          onClose={handleCloseEditUnitModal}>
          <EditUnit
            handleEditUnit={handleEditUnits}
            unitId={UnitId}
            isSubmitting={isSubmitting}
            activeLevelType={activeLevelType}
            data={unitDetailsForEdit}
            onClose={handleCloseEditUnitModal}
          />
        </Modal>
      )}

      {showBulkAssignModal && (
        <Modal
          isDirty
          confirmOnClose
          name="Assign Sales Manager"
          width={48}
          onClose={() => setShowBulkAssignModal(false)}>
          <BulkAssignSalesManagerModal
            units={bulkAssignUnitsList}
            salesManagerOptions={salesManagerOptions}
            isSubmitting={isBulkAssignSubmitting}
            onClose={() => setShowBulkAssignModal(false)}
            onSubmit={handleBulkAssignSubmit}
          />
        </Modal>
      )}
      {isOpenAddNewBlock && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={68}
          name={'Add New Block'}
          onClose={() => setIsOpenAddNewBlock(!isOpenAddNewBlock)}>
          <AddNewBlock
            setIsOpenAddNewBlock={setIsOpenAddNewBlock}
            onProceed={handleAddBlock}
            isSubmitting={isSubmitting}
            projectId={projectId}
            onClose={() => setIsOpenAddNewBlock(false)}
            setisSubmitting={setIsSubmitting}
            buildingByProjectId={buildingByProjectId}
            setIsOpenEditProject={setIsOpenEditProject}
          />
        </Modal>
      )}

      {/* Edit Project Modal */}
      {isOpenEditProject && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={88}
          name="Edit project"
          onClose={() => setIsOpenEditProject(false)}
          upShift={upShift * 10}>
          <EditProject
            id={projectId}
            ProjectData={projectData}
            upShift={upShift}
            isSubmitting={isSubmitting}
            setUpShift={setUpShift}
            onSubmit={handleEditProject}
            onClose={() => setIsOpenEditProject(false)}
          />
        </Modal>
      )}

      {isOpenEditLevelUnitModal && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name={'Unit Detailing'}
          width={55}
          onClose={async () => {
            setisOpenEditLevelModal(false);
            const block = await refetchBlock();
            // Find the current level id (after unit creation, usually the last edited level)
            let levelId = null;
            if (levelsDyna && levelsDyna.length > 0) {
              // If only one level, use its id; otherwise, use the last one edited
              levelId =
                levelsDyna.length === 1
                  ? levelsDyna[0]?.id
                  : levelsDyna[currentLevelIndex]?.id || levelsDyna[0]?.id;
            }
            if (levelId) {
              handleViewForType(levelId);
            }
          }}
          hideClose={true}>
          <EditLevel
            handleEditLevel={handleEditLevel}
            data={levelsDyna}
            currentLevelIndex={currentLevelIndex}
            noOflevel={blockLevelNumber}
            setCurrentLevelIndex={setCurrentLevelIndex}
            allAccommodations={accommodations}
            onClose={() => {
              setisOpenEditLevelModal(false);
              refetchBlock();
            }}
            blockType={blockType}
            blockName={currentBlockName}
            blockSaved={isSaved}
            prevLevelData={prevLevelData}
          />
        </Modal>
      )}

      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || `this ${deleteType === 'Block' ? 'block' : deleteType === 'Level' ? 'level' : deleteType === 'Unit' ? 'unit' : 'item'}`}'`}
          onClose={() => setCanDelete(null)}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            {deleteType !== 'Unit' ? (
              <p className="text-center">
                Looks like this{' '}
                {deleteType === 'Block' ? 'block' : deleteType === 'Level' ? 'level' : 'item'} has
                dependencies, please delete following{' '}
                {deleteType === 'Block' ? 'levels' : deleteType === 'Level' ? 'units' : 'item'} to
                proceed
              </p>
            ) : (
              <p className="text-center">Looks like this unit is already booked.</p>
            )}
            {deleteType !== 'Unit' && (
              <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
                {resData &&
                  resData.reason?.map((r, index) => (
                    <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                      {index + 1}.{r}
                      {index < resData.reason.length - 1 ? ', ' : ''}
                    </span>
                  ))}
              </div>
            )}
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={
              deleteType === 'Block'
                ? 'block'
                : deleteType === 'Level'
                  ? 'level'
                  : deleteType === 'Unit'
                    ? 'unit'
                    : 'item'
            }
            onClose={() => setCanDelete(null)}
            data={
              deleteType === 'Block'
                ? blocksDyna
                : deleteType === 'Level'
                  ? BlockDataId
                  : deleteType === 'Unit'
                    ? dataFieldUnits
                    : []
            }
            type={
              deleteType === 'Block'
                ? 'block'
                : deleteType === 'Level'
                  ? 'level'
                  : deleteType === 'Unit'
                    ? 'unit'
                    : 'item'
            }
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      <div
        className={`w-full flex flex-col transition-all duration-300 ease-in-out mt-3 pl-5 pr-5 bg-gray-100 overflow-hidden `}>
        {(isEditBlockLevel || isAllUnitDataSubmitted) && (
          <div className="flex bg-white p-3 items-center justify-end rounded-md">
            <div className="flex gap-3">
              {isEditBlockLevel && (
                <Button onClick={handleSubmit(handlePreviewCreatedBlock)} type="submit">
                  Proceed
                </Button>
              )}
              {isAllUnitDataSubmitted && <Button onClick={handleSaveAddBlock}>Save</Button>}
            </div>
          </div>
        )}
        {!isEditBlockLevel && !isAllUnitDataSubmitted && (newBlockId || viewUnits) && (
          <div className="flex px-3 py-1 items-center justify-between rounded-md">
            <h3 className="text-xl font-semibold cursor-pointer flex gap-2 items-center">
              <span className="text-black" onClick={goBackToBlocks}>
                {`${currentBlockName ? ` ${currentBlockName}` : ''}`}
              </span>
              {newBlockId && !viewUnits && (
                <>
                  <span className="text-gray-400">›</span>
                  <span>{'Level'}</span>
                </>
              )}
              {viewUnits && (
                <>
                  <span className="text-gray-400">›</span>
                  <span className="text-black" onClick={backToLevels}>
                    {`${HeaderByLevelName ? ` ${HeaderByLevelName}` : ''}`}
                  </span>
                  <span className="text-gray-400">›</span>
                  <span>{'Unit'}</span>
                </>
              )}
            </h3>
            <div className="flex gap-3">
              {isEditBlockLevel && (
                <Button onClick={handleSubmit(handlePreviewCreatedBlock)} type="submit">
                  Proceed
                </Button>
              )}
              {isAllUnitDataSubmitted && <Button onClick={handleSaveAddBlock}>Save</Button>}
            </div>
          </div>
        )}

        {showRowLevelStats && (
          <div className="mt-3 flex flex-wrap gap-3">
            <MetricCard
              title={type === 'Independent' ? 'Total Rows' : 'Total Levels'}
              value={totalRowsOrLevels}
              icon={<Ruler size={18} />}
              iconBgClass="bg-[#EEF2FF]"
              iconColorClass="text-[#4F46E5]"
              valueColorClass="text-[#3730A3]"
              borderClass="border-[#DDE3F8]"
              className="w-full sm:w-[260px]"
            />
            <MetricCard
              title="Total Units"
              value={totalUnitsInSelectedBlock}
              icon={<Building2 size={18} />}
              iconBgClass="bg-[#E9F8F1]"
              iconColorClass="text-[#0F766E]"
              valueColorClass="text-[#0F766E]"
              borderClass="border-[#CFEBDD]"
              className="w-full sm:w-[260px]"
            />
            <MetricCard
              title="Accommodation Types"
              value={totalDistinctAccommodationNames}
              icon={<List size={18} />}
              iconBgClass="bg-[#FEF3C7]"
              iconColorClass="text-[#B45309]"
              valueColorClass="text-[#B45309]"
              borderClass="border-[#FDE68A]"
              className="w-full sm:w-[260px]"
            />
          </div>
        )}
        {showUnitLevelStats && (
          <div className="mt-3 flex w-full flex-wrap items-start justify-between gap-3">
            <div className="flex flex-wrap gap-3">
              <MetricCard
                title="Total Units"
                value={unitsTotalInLevelView}
                icon={<Building2 size={18} />}
                iconBgClass="bg-[#EAF4F7]"
                iconColorClass="text-[#2A565E]"
                valueColorClass="text-[#2A565E]"
                borderClass="border-[#D7E8EE]"
                className="w-full sm:w-[260px]"
              />
              <MetricCard
                title="Total Vacant"
                value={unitsVacantInLevelView}
                icon={<CircleDot size={18} />}
                iconBgClass="bg-[#FFF7ED]"
                iconColorClass="text-[#C2410C]"
                valueColorClass="text-[#C2410C]"
                borderClass="border-[#FED7AA]"
                className="w-full sm:w-[260px]"
              />
              <MetricCard
                title="Total Booked"
                value={unitsBookedInLevelView}
                icon={<CheckCircle2 size={18} />}
                iconBgClass="bg-[#F5F3FF]"
                iconColorClass="text-[#6D28D9]"
                valueColorClass="text-[#6D28D9]"
                borderClass="border-[#DDD6FE]"
                className="w-full sm:w-[260px]"
              />
            </div>
            {showBulkSalesManagerAssign && (
              <div className="ml-auto flex shrink-0 items-center">
                <Button type="button" onClick={() => setShowBulkAssignModal(true)}>
                  Assign Sales Manager
                </Button>
              </div>
            )}
          </div>
        )}

        {showOverviewStatsAndFilters && (
          <div className="mt-3 flex flex-wrap gap-3">
            <MetricCard
              title="Total Blocks"
              value={totalBlocks}
              icon={<LayoutGrid size={18} />}
              iconBgClass="bg-[#EAF4F7]"
              iconColorClass="text-[#2A565E]"
              valueColorClass="text-[#2A565E]"
              borderClass="border-[#D7E8EE]"
              className="w-full sm:w-[260px]"
            />
            <MetricCard
              title="Total Levels / Rows"
              value={totalLevelsOrRows}
              icon={<Ruler size={18} />}
              iconBgClass="bg-[#EEF2FF]"
              iconColorClass="text-[#4F46E5]"
              valueColorClass="text-[#3730A3]"
              borderClass="border-[#DDE3F8]"
              className="w-full sm:w-[260px]"
            />
            <MetricCard
              title="Total Units"
              value={totalUnits}
              icon={<Building2 size={18} />}
              iconBgClass="bg-[#E9F8F1]"
              iconColorClass="text-[#0F766E]"
              valueColorClass="text-[#0F766E]"
              borderClass="border-[#CFEBDD]"
              className="w-full sm:w-[260px]"
            />
          </div>
        )}

        {showOverviewStatsAndFilters && (
          <div className="mt-3 rounded-xl border border-[#E7EBF1] bg-white p-3 shadow-sm">
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
              <div className="flex flex-1 flex-col gap-3 sm:flex-row">
                <div className="relative w-full sm:max-w-[280px]">
                  <Search
                    size={16}
                    className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]"
                  />
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(event) => setSearchQuery(event.target.value)}
                    placeholder="Search block name"
                    className="w-full rounded-lg border border-[#D8DEE7] bg-[#F8FAFC] py-2 pl-9 pr-3 text-sm text-[#334155] outline-none focus:border-[#2A565E]"
                  />
                </div>

                <select
                  value={blockTypeFilter}
                  onChange={(event) => setBlockTypeFilter(event.target.value)}
                  className="rounded-lg border border-[#D8DEE7] bg-[#F8FAFC] px-3 py-2 text-sm text-[#334155] outline-none focus:border-[#2A565E]">
                  {blockTypeOptions.map((typeOption) => (
                    <option key={typeOption} value={typeOption}>
                      {typeOption === 'all' ? 'Block Type' : typeOption}
                    </option>
                  ))}
                </select>
              </div>

              <div className="inline-flex items-center rounded-xl border border-[#DCE3EA] bg-white p-1 shadow-sm shrink-0">
                <button
                  type="button"
                  onClick={() => setViewMode('card')}
                  className={`h-9 px-4 rounded-lg inline-flex items-center justify-center gap-1.5 text-[13px] font-semibold transition-colors ${
                    viewMode === 'card'
                      ? 'bg-[#EEF2F5] text-[#617087]'
                      : 'text-[#7A879B] hover:text-[#617087]'
                  }`}
                  aria-label="Card view">
                  <LayoutGrid size={14} />
                  <span>Card View</span>
                </button>
                <button
                  type="button"
                  onClick={() => setViewMode('table')}
                  className={`h-9 px-4 rounded-lg inline-flex items-center justify-center gap-1.5 text-[13px] font-semibold transition-colors ${
                    viewMode === 'table'
                      ? 'bg-[#EEF2F5] text-[#0F4D52]'
                      : 'text-[#7A879B] hover:text-[#617087]'
                  }`}
                  aria-label="Table view">
                  <List size={14} />
                  <span>Table View</span>
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="mt-5 h-full">
          {isEditBlockLevel && (
            // Usage in the EditTable component
            <div className="Editlevel-table-container">
              <style>{`
                  .Editlevel-table-container .table-body {
                    position: static !important;
                    overflow-y: visible !important;
                    max-height: none !important;  
                    height: auto !important;
                    top: auto !important;
                    padding-bottom: 0 !important;
                  }
                  .Editlevel-table-container .table-container {
                    height: auto !important;
                  }
                  .Editlevel-table-container > div {
                    height: auto !important;  
                  }
                `}</style>

              <EditTable
                headers={['Level Name', 'Floor Type', 'No of Units']}
                data={blocksArray}
                isEditEnable={false}
                onRegister={register}
                blockType={blockType}
                editTableType={'LevelEdit'}
                onType={(value, index) => isTypingNow(value, index)} // Pass the index here
                identifier={'id'}
                isWrap={true}
              />
            </div>
          )}

          {isEditBlockLevel && (
            <button
              type="button"
              onClick={handleAddFloatingLevel}
              className="fixed bottom-8 right-8 z-50 h-14 w-14 rounded-full bg-[#2B6777] text-white shadow-lg hover:bg-[#1f4f5c] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2B6777]"
              aria-label="Add level">
              <Plus className="mx-auto" size={24} />
            </button>
          )}

          {showBlockCards && (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 pb-3">
              <button
                type="button"
                onClick={() => setIsOpenAddNewBlock(true)}
                className="rounded-2xl border-2 border-dashed border-[#BFD4D8] bg-white text-[#2A565E] flex flex-col items-center justify-center gap-1.5 shadow-sm hover:bg-[#F7FBFC] hover:border-[#9EC5CC] transition-colors min-h-[160px]">
                <span className="h-9 w-9 rounded-full bg-[#E8F3F5] flex items-center justify-center">
                  <Plus size={22} />
                </span>
                <span className="text-sm font-semibold">Add Block</span>
              </button>

              {filteredBlocks?.map((block) => {
                const levelCount = block?.levels?.length || 0;
                const unitCount =
                  block?.levels?.reduce((total, level) => total + (level?.units?.length || 0), 0) ||
                  0;
                const allUnits = block?.levels?.flatMap((level) => level?.units || []) || [];
                const accommodationTypeCount = new Set(
                  allUnits.map((unit) => unit?.accommodation?.name).filter((name) => Boolean(name))
                ).size;
                const blockAreaFromUnits = allUnits.reduce((total, unit) => {
                  const areaValue =
                    Number(unit?.accommodation?.buildUpArea) ||
                    Number(unit?.accommodation?.plotArea) ||
                    Number(unit?.accommodation?.superBuiltUpArea) ||
                    0;
                  return total + areaValue;
                }, 0);
                const blockArea =
                  Number(block?.blockArea) ||
                  Number(block?.area) ||
                  Number(block?.totalArea) ||
                  blockAreaFromUnits;
                const operationsManagerName = block?.operationsManager?.name;

                return (
                  <div
                    key={block?.id}
                    tabIndex={0}
                    aria-label={`View block ${block?.name || ''}`.trim()}
                    onClick={() => handleBlockRowClick(block?.id)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleBlockRowClick(block?.id);
                      }
                    }}
                    className="relative self-start flex h-fit min-h-[200px] cursor-pointer flex-col overflow-hidden rounded-2xl border border-[#E5E7EB] bg-white shadow-sm hover:shadow-md transition-shadow focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2B6777] focus-visible:ring-offset-2">
                    <div className="absolute right-3 top-3 z-10 flex flex-row-reverse items-center gap-2">
                      <button
                        type="button"
                        className="flex h-9 w-9 items-center justify-center rounded-full border border-[#E5E7EB] bg-white text-[#4B5563] transition-colors hover:border-[#D1D5DB] hover:bg-[#F9FAFB] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#CBD5E1] focus-visible:ring-offset-1"
                        aria-label="Delete block"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteBlockRow(block?.id);
                        }}>
                        <Trash2 size={17} strokeWidth={1.5} className="shrink-0" />
                      </button>
                      <button
                        type="button"
                        className="flex h-9 w-9 items-center justify-center rounded-full border border-[#E5E7EB] bg-white text-[#4B5563] transition-colors hover:border-[#D1D5DB] hover:bg-[#F9FAFB] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#CBD5E1] focus-visible:ring-offset-1"
                        aria-label="Edit block"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditBlockRow(block?.id);
                        }}>
                        <Pencil size={17} strokeWidth={1.5} className="shrink-0" />
                      </button>
                    </div>
                    <div className="border-b border-[#F1F5F9] px-3.5 pt-3.5 pb-2.5 pr-[5.5rem]">
                      <div className="flex items-center gap-2">
                        <h4 className="text-[20px] leading-none font-semibold text-[#17464B]">
                          {block?.name || '--'}
                        </h4>
                        <span className={blockTypeTagClassName(block?.type)}>
                          {block?.type || '--'}
                        </span>
                      </div>
                      <p className="mt-1.5 text-sm leading-none text-[#6B7280]">
                        {levelCount} Levels <span className="mx-1">|</span> {unitCount} Units Total
                      </p>
                    </div>

                    <div className="px-3.5 py-3">
                      <div className="grid grid-cols-2 gap-3">
                        <div className="flex items-start gap-2 min-w-0">
                          <span className="mt-0.5 text-[#5B7D83]">
                            <Building2 size={16} />
                          </span>
                          <div className="min-w-0">
                            <p className="text-[13px] leading-none text-[#8A94A6]">Accommodation</p>
                            <p className="mt-1 text-[16px] leading-none font-semibold text-[#3F6668] truncate">
                              {accommodationTypeCount > 0
                                ? `${accommodationTypeCount} ${accommodationTypeCount === 1 ? 'type' : 'types'}`
                                : '--'}
                            </p>
                          </div>
                        </div>

                        <div className="flex items-start gap-2 min-w-0">
                          <span className="mt-0.5 text-[#5B7D83]">
                            <Ruler size={16} />
                          </span>
                          <div className="min-w-0">
                            <p className="text-[13px] leading-none text-[#8A94A6]">Block Area</p>
                            <p className="mt-1 text-[16px] leading-none font-semibold text-[#3F6668] truncate">
                              {blockArea ? `${blockArea.toLocaleString()} sq ft` : '--'}
                            </p>
                          </div>
                        </div>

                        {operationsManagerName && (
                          <div className="col-span-2 flex items-start gap-2 min-w-0">
                            <span className="mt-0.5 text-[#5B7D83]">
                              <User size={16} />
                            </span>
                            <div className="min-w-0">
                              <p className="text-[13px] leading-none text-[#8A94A6]">
                                Operations Manager
                              </p>
                              <p className="mt-1 text-[16px] leading-none font-semibold text-[#3F6668] truncate">
                                {operationsManagerName}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {!isEditBlockLevel && !showBlockCards && (
            <BlockHierarchy
              blocksRows={blocksTableRows}
              levelsRows={BlockDataId}
              unitsRows={dataFieldUnits}
              unitHeaders={headers}
              selectedBlockId={isEditingBlock ? null : newBlockId}
              isViewUnits={viewUnits}
              onClickBlock={handleBlockRowClick}
              onEditBlock={handleEditBlockRow}
              onDeleteBlock={handleDeleteBlockRow}
              onAddBlock={() => setIsOpenAddNewBlock(true)}
              onClickLevel={handleLevelClick}
              onDeleteLevel={(id) => {
                setDeleteType('Level');
                handleDeleteLevel(id);
              }}
              onAddLevel={addLevelHandler}
              onEditUnit={(id) => handleEditUnitById(id)}
              onDeleteUnit={(id) => {
                setDeleteType('Unit');
                handleDeleteUnit(id);
              }}
              onAddUnit={addUnitHandler}
              showAddButtons={
                !isEditBlockLevel &&
                !isOpenAddNewBlock &&
                !isAllUnitDataSubmitted &&
                !isUpdateLevelModalOpen &&
                !isUpdateUnitModalOpen &&
                !isEditingBlock &&
                !isEditUnit
              }
            />
          )}
        </div>
      </div>
    </>
  );
};
